module.exports = __webpack_public_path__ + "img/betflix-support.729a88e9.png";